
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { PrescriptionAction, PrescriptionMutation, PrescriptionState } from '@/store/Prescription/PrescriptionRoot';

// Utils
import { snakeCase } from 'lodash';

// Interfaces
import { IncludeLaborProtectionAccident } from '@/ship/Models/Prescriptions/LaborProtection';
import Pagination from '@/ship/Models/Pagination';

// Components
import LaborProtectionAccidentsList from '@/components/Prescription/LaborProtectionAccidentsList.vue';

// Enums
import ModalEnum from '@/ship/Enums/ModalEnum';

@Component({
    components: {
        LaborProtectionAccidentsList,
    },
})
export default class LaborProtectionAccidents extends Vue {
    @PrescriptionAction GET_LABOR_PROTECTION_ACCIDENTS!: (param: {
        page: number;
        query: string;
    }) => Promise<IncludeLaborProtectionAccident[]>;
    @PrescriptionState laborProtectionAccidents!: IncludeLaborProtectionAccident[];
    @PrescriptionState pagination!: Pagination;
    @PrescriptionMutation RESET_LABOR_PROTECTION_ACCIDENTS!: () => void;
    @Ref() refScroll!: HTMLDivElement;
    @Ref() refSecondaryPage!: HTMLDivElement;

    isSecondaryPageOpen = false;
    isCreateAccident = true;
    isFirstTime = false;
    selectorKey = 0;
    page = 1;
    isRequestReady = true;

    mounted() {
        this.routeType();
        window.addEventListener('wheel', this.selectWheel);
        window.addEventListener('pointerover', this.checkDevice);
    }

    beforeDestroy() {
        window.removeEventListener('wheel', this.selectWheel);
        window.removeEventListener('pointerover', this.checkDevice);
    }

    checkDevice(e: PointerEvent) {
        if (e.pointerType === 'touch') {
            this.selectWheel();
        }
    }

    /**
     * Проверка на то, сколько px осталось до конца списка
     * При достижении данного параметра произвести запрос на получение предписаний
     * Проверку осуществлять после 200 мс
     */
    selectWheel() {
        setTimeout(() => {
            const { scrollTop, scrollHeight } = this.refScroll;
            const { clientHeight } = document.documentElement;

            if (scrollTop + clientHeight >= scrollHeight - 10 && this.isRequestReady && this.pagination) {
                if (this.pagination.currentPage <= this.pagination.totalPages) {
                    this.isRequestReady = false;
                    this.urlParser().then(() => {
                        this.isRequestReady = true;
                    });
                }
            }
        }, 200);
    }

    /**
     * Convert query url from ?firstParam=param1&secondParam=param2
     * to first_param:param1;second_param:param2
     *
     * API call to load all laborProtectionAccidents
     */
    async urlParser() {
        const query = Object.entries(this.$route.query).reduce((search, [key, value]) => {
            const isKeyAllowed = /(search|date|cityId|projectId|generalContractorId)/g.test(key);
            if (!isKeyAllowed) return search;

            key = key.includes('.') ? key : snakeCase(key);
            return search + `${key}:${value};`;
        }, '');

        const page = this.pagination ? this.pagination.currentPage + 1 : 1;

        await this.GET_LABOR_PROTECTION_ACCIDENTS({ page, query });
    }

    @Watch('$route', { deep: true })
    async routeType() {
        if (this.$route.name === 'labor.accident.view') {
            this.changeToDisplayAccidents();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'labor.accident.create') {
            this.changeToCreateAccidents();
            this.openSecondaryPage();
            this.reloadSelectorForm();
        }

        if (this.$route.name === 'labor.accidents') {
            this.isSecondaryPageOpen = false;
            if (!Object.keys(this.$route.query).length) {
                this.RESET_LABOR_PROTECTION_ACCIDENTS();
            }
        }

        if (!this.laborProtectionAccidents) await this.urlParser();

        if (
            !this.laborProtectionAccidents?.length &&
            (this.$route.name === 'labor.accidents' || this.$route.name === 'labor.accident.view')
        ) {
            this.$modal.show(ModalEnum.Alert, {
                title: 'По выбранным критериям чек-листов не найдено. Попробуйте применить другие фильтры.',
                actionLabel: this.$t('page.modal.answer.understand'),
            });
        }
    }

    reloadSelectorForm() {
        this.selectorKey++;
    }

    changeToDisplayAccidents() {
        this.isCreateAccident = false;
    }

    changeToCreateAccidents() {
        this.isCreateAccident = true;
    }

    openSecondaryPage() {
        this.isSecondaryPageOpen = true;
    }

    closeSecondaryPage() {
        this.isSecondaryPageOpen = false;
    }

    updateAccidents() {
        this.RESET_LABOR_PROTECTION_ACCIDENTS();
        this.urlParser();
    }
}
